<script lang="ts" setup>
  const props = defineProps<{
    environment: keyof typeof environments
  }>()

  const { t } = useI18n()

  const environments = {
    portal: { color: 'text-primary', title: '' },
    management: { color: 'text-affirmative', title: 'Management' },
    academy: { color: 'text-critical', title: 'Academy' },
    cms: { color: 'text-black', title: 'CMS' },
    settings: { color: 'text-black', title: '' },
  }
  const route = useRoute()
  const localePath = useLocalePath()
  const selectedEnvironment = computed(() => environments[props.environment])
  const authStore = useAuthStore()
  const { normalizePath } = useLocalizedPath()
  const helpdeskLink = computed(() => localePath('/portal/helpdesk'))
  const homePath = computed(() => {
    return normalizePath(route.path).startsWith('/portal')
      ? localePath('/portal/dashboard')
      : localePath('/hub/dashboard')
  })
</script>

<template>
  <header
    class="h-20 px-3 sm:px-4 lg:px-12 border-b border-[#e3e3e3] flex items-center gap-2 lg:gap-6 shrink-0 bg-white"
  >
    <div id="logo" class="flex-shrink-0">
      <NuxtLink :to="homePath">
        <img
          alt="logo"
          src="/icons/Logo.svg"
          width="181"
          height="35"
          class="h-auto w-28 sm:h-8 sm:w-auto"
        />
      </NuxtLink>
    </div>
    <div v-if="selectedEnvironment.title" id="env" class="lg:px-6 flex-shrink-0">
      <h3 :class="selectedEnvironment.color" class="text-lg lg:text-2xl font-bold">
        <!-- Show full title on large screens and up -->
        <span class="hidden lg:inline">{{ selectedEnvironment.title }}</span>
        <!-- Show abbreviated title on smaller screens for management -->
        <span v-if="environment === 'management'" class="lg:hidden">Mgmt</span>
      </h3>
    </div>
    <div v-if="environment === 'portal' && authStore.isEmployee" class="min-w-0 flex-1 max-w-xl">
      <PortalGlobalSearch />
    </div>
    <div class="flex shrink-0 items-center gap-2 lg:gap-3 ml-auto">
      <div class="flex flex-row gap-1 lg:gap-2" driver-id="helpdesk-button">
        <BasicBtn
          class="flex min-h-11 min-w-11 items-center justify-center gap-1 px-2 lg:px-6"
          :aria-label="t('nav.menu.helpdeskButton')"
          size="regular"
          type="submit"
          color="affirmative"
          is-link
          :link="helpdeskLink"
          target="_self"
        >
          <Icon name="material-symbols:help-outline" class="w-5 h-5" />
          <span class="hidden lg:inline">{{ t('nav.menu.helpdeskButton') }}</span>
        </BasicBtn>
      </div>
      <TheProfileMenu
        id="profile-menu"
        :environment="environment === 'management' ? 'management' : 'portal'"
      />
    </div>
  </header>
</template>

<style scoped></style>
